import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69adfd40886e10001451db07/haalproject/src/app/subhaal/masjid-al-ihsan/components/MasjidFooter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69adfd40886e10001451db07/haalproject/src/app/subhaal/masjid-al-ihsan/components/MasjidHeader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69adfd40886e10001451db07/haalproject/src/app/subhaal/masjid-al-ihsan/media/MediaPageClient.tsx");
